module.exports = __webpack_public_path__ + "img/008.ee42cae7.png";